/**
 * Centralized API Configuration
 * 
 * All API calls should import from this file.
 * In Create React App, environment variables must be prefixed with REACT_APP_.
 * 
 * Usage:
 *   import { API_BASE_URL, API_URL } from '../config/api';
 */

// The base server URL (no trailing slash, no /api)
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// The API endpoint base (with /api suffix)
export const API_URL = `${API_BASE_URL}/api`;

export default API_URL;
